<template>
  <div>
    <modal-component
      :active="showModal"
      @cancel="close"
      :titleModal="'Agregar webhook'"
      @hdlOnClick="addNewWebhook"
      :loading="loading"
      :loader="loading"
    >
        <div class="columns is-multiline">
          <div class="column is-6">
            <div class="field">
              <label class="label has-text-grey-light">Evento</label>
              <div class="select is-fullwidth" :class="{'is-danger': vverrors.has('eventId')}">
                <select
                  class="select"
                  v-model="webhookId"
                  name="webhookId"
                  v-validate="'required'"
                >
                  <option value="" selected disabled> Selecciona un evento </option>
                  <option  v-for="event in events" :value="event.id" :key="event.id"> {{event.name}} </option>
                </select>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="field">
              <label class="label has-text-grey-light">URL</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  placeholder="URL"
                  v-model="url"
                  name="url"
                  v-validate="'required'"
                  :class="{'is-danger': vverrors.has('url')}"
                >
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="control">
              <a href="#" class="has-text-link is-size-7 has-text-weight-bold" @click="probarWebhook()">Probar webhook</a>
            </div>
          </div>
          <div class="column is-12">
            <div class="field">
              <label class="label has-text-grey-light">Headers</label>
              <div class="control">
                <textarea class="textarea" rows="4" name="headers" v-model="headers" placeholder="Headers"></textarea>
              </div>
            </div>
          </div>
          <div class="column is-12">
            <div class="field">
              <label class="label has-text-grey-light">Descripción</label>
              <div class="control">
                <textarea
                class="textarea"
                rows="4"
                name="description"
                v-model="description"
                placeholder="Descripción"
                v-validate="'required'"
                :class="{'is-danger': vverrors.has('description')}"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
    </modal-component>
    <ModalTestWebhook
      :showModalTest="showModalTest"
      :closeModalTest="closeModalTest"
      :eventName="eventName"
      :webhookUrl="url"
      :webhookHeader="headers"
      :statusCode="statusCode"
      :respBody="respBody"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '../../mixins/formats'
export default {
  name: 'Webhooks',
  components: {
    ModalComponent: () => import('@/components/ui/ModalComponent'),
    ModalTestWebhook: () => import('@/components/Webhook/ModalTestWebhook.vue')
  },
  mixins: [mixins],
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      default: () => {}
    },
    actionSuccess: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      loading: false,
      loadingTest: false,
      showModalTest: false,
      events: [],
      eventName: '',
      headers: null,
      url: null,
      description: null,
      webhookId: Number,
      error: '',
      statusCode: null,
      respBody: null
    }
  },
  methods: {
    ...mapActions(['getFinancialEvents', 'addWebhook']),
    async getEventsList () {
      this.getFinancialEvents({ pagination: { pageNumber: 1, perPage: 100 }, paginator: false })
        .then(({ eventPages }) => {
          this.events = eventPages
        })
    },
    async addNewWebhook () {
      if (await this.$validator.validateAll()) {
        this.loading = true
        const data = {
          url: this.url,
          event: this.webhookId,
          description: this.description,
          headers: this.headers
        }
        const webhook = await this.addWebhook(data)
        if (webhook && webhook.success) {
          this.close()
          this.actionSuccess()
        }
        this.loading = false
      }
    },
    async probarWebhook () {
      this.loadingTest = true
      this.showModalTest = true
      const urlRegex = /^(https?):\/\/[^\s/$.?#].[^\s]*$/i
      try {
        const isValidUrl = urlRegex.test(this.url)

        if (!isValidUrl) {
          this.loadingTest = false
          this.showModalTest = false
          this.$store.dispatch('addTemporalNotification', {
            type: 'danger',
            message: 'La URL no es válida. Por favor, ingresa una URL válida.'
          })
          return
        }

        const payload = {
          data: { sample: true }
        }

        // Asegurar que headers sea un objeto
        let headers = {}
        headers = this.headers && typeof this.headers === 'string'
          ? JSON.parse(this.headers)
          : (typeof this.headers === 'object' ? this.headers : {})

        headers['Access-Control-Allow-Origin'] = '*'

        const response = await fetch(this.url, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(payload)
        })

        if (!response.ok) {
          this.$store.dispatch('addTemporalNotification', {
            type: 'danger',
            message: `La prueba del webhook falló con el código de estado ${response.status}.`
          })
          this.loadingTest = false
        }

        const contentType = response?.headers.get('content-type') || ''
        const responseBody =
          contentType.includes('application/json')
            ? JSON.stringify(await response.json())
            : await response.text()

        this.eventName = this.events.find(event => event.id === this.webhookId)?.name || ''
        this.statusCode = response.status
        this.respBody = responseBody
        this.loadingTest = false
      } catch (error) {
        this.loadingTest = false
        this.showModalTest = false
        // Aquí detectas errores de red o CORS
        if (error instanceof TypeError && error.message === 'Failed to fetch') {
          this.$store.dispatch('addTemporalNotification', {
            type: 'danger',
            message: 'No se pudo conectar con el servidor. Es posible que haya un error de CORS o un problema de red.'
          })
        } else {
          this.$store.dispatch('addTemporalNotification', {
            type: 'danger',
            message: 'Ocurrió un error inesperado. Intente de nuevo más tarde.'
          })
        }
      }
    },
    closeModalTest () {
      this.showModalTest = false
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration
    })
  },
  mounted () {
    this.getEventsList()
  }

}
</script>
